/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../../../../components/Button';
import backImg from '../../../../assets/images/Fireboard/back_arrow_white.png';
import classes from './Header.module.css';

const Header = ({ goBack, showBack, onChangeSortBy, sortByTime }) => {
  return (
    <div className={classes.container}>
      {showBack && (
        <Button className={classes.button} onClick={goBack}>
          <img src={backImg} className={classes.backImg} alt='back' />
          <span className={classes.buttonText}>Go to Fireboard</span>
        </Button>
      )}
      <span className={classes.onedine}>onedine</span>
      <div className={classes.switchContainer}>
        <span className={classes.sortByTimeTxt}>Sort By Time</span>
        <div className={classes.toggleContainer} onClick={onChangeSortBy}>
          <div className={classNames({ [classes.dialogButton]: true, [classes.disabled]: sortByTime })} />
        </div>
        <span className={classes.sortByTimeTxt}>Sort By Name</span>
      </div>
    </div>
  )
};

export default Header;

Header.propTypes = {
  goBack: PropTypes.func,
  showBack: PropTypes.bool,
  onChangeSortBy: PropTypes.func,
  sortByTime: PropTypes.bool,
};

Header.defaultProps = {
  goBack: () => { },
  showBack: false,
  onChangeSortBy: () => { },
  sortByTime: true,
};
